<template>
  <div>

      <div ref="heading" key="dynamic">
        <slot name="page-heading"></slot>
      </div>
        <transition-group ref="tableHeader" name="slide-fade" class="table-panel pt-3"
                      :style="{ backgroundColor: getBackgroundColor}"
                      tag="div">
      <slot name="header" :isFixed="isFixed"></slot>
    </transition-group>
    <div class="overflown" :class="{'overflown-fixed': isFixed }"
         v-scroll="handleScroll">
      <slot name="table"></slot>
    </div>
  </div>
</template>

<script>
  /*
  Note the "table" that is slotted in uses the following methods
   - updateScrollTop, saves the scroll position
   - refreshTableOnScroll, loads a pageful of rows
  */
  export default {
    name: 'FilteredTable',
    data () {
      return {
        isFixed: false,
        currentScroll: 0
      }
    },
    mounted () {
      window.scrollTo(0, this.getTable().scrollTop || 0)
    },
    beforeDestroy () {
      this.getTable().updateScrollTop(this.currentScroll)
    },
    methods: {
      getTable () {
        return this.$slots.table[0].componentInstance
      },
      handleScroll (event) {
        // For fixing the header to the top. Change accordingly
        const triggerOut = 100
        const triggerIn = 100
        const scrollTop = window.scrollY
        const totalScroll = document.body.scrollHeight
        const clientHeight = window.innerHeight

        // Prevent list with small number of elements from fidgeting between fixed and not fixed
        if (this.isFixed) {
          if (scrollTop < triggerIn) {
            this.isFixed = false
          }
        } else {
          if (scrollTop >= triggerOut) {
            this.isFixed = true
          }
        }

        const scrollTrigger = 250
        if (totalScroll - clientHeight - scrollTop < scrollTrigger) {
          this.getTable().refreshTableOnScroll()
        }

        this.currentScroll = scrollTop
      }
    },
    computed: {
      getBackgroundColor () {
        return this.$vuetify.dark ? '#303030' : '#FAFAFA'
      }
    }
  }
</script>

<style scoped>

  .progress-linear {
    margin: -5px 0 0;
  }

  .table-panel {
    position: -webkit-sticky;
    position: sticky;
    top: 48px;
    z-index: 3;
  }

  .overflown {
    overflow-x: hidden;
  }

  .align-self-center {
    align-self: center;
  }

  .slide-fade-move {
    transition: transform .5s ease;
  }

  .slide-fade-enter-active {
    transition: all .5s ease;
  }

  .slide-fade-leave-active {
    transition: all .3s cubic-bezier(1.0, 0.5, 0.8, 1.0);
    position: absolute;
  }

  .slide-fade-enter, .slide-fade-leave-to {
    transform: translateX(10px);
    opacity: 0;
  }
</style>



// WEBPACK FOOTER //
// src/components/FilteredTable.vue